import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import {
    ContactSection, BadgeListSection, SocialSection,
    AboutSection, ExperienceSection, EducationSection, ReferencesSection,
} from './PdfSections';

const styles = StyleSheet.create({
    page: { padding: 30, fontSize: 10, fontFamily: 'Helvetica', backgroundColor: '#F6F6F6' },
    name: { fontSize: 18, fontWeight: 'bold', marginBottom: 4 },
    title: { fontSize: 11, marginBottom: 10 },
    row: { flexDirection: 'row', marginBottom: 10 },
    col: { flex: 1, paddingRight: 10 },
});

function Template7Pdf(props) {
    const {
        name, about, email, address, phone, title,
        technicalSkills, languages, softSkills,
        linkedinURL, twitterURL, githubURL, websiteURL,
        educationData, jobData, showSocial, referenceData,
    } = props;

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <Text style={styles.name}>{name}</Text>
                <Text style={styles.title}>{title}</Text>
                <View style={styles.row}>
                    <View style={styles.col}><AboutSection about={about} /></View>
                    <View style={styles.col}>
                        <ContactSection email={email} phone={phone} address={address} />
                        <SocialSection linkedinURL={linkedinURL} twitterURL={twitterURL} githubURL={githubURL} websiteURL={websiteURL} showSocial={showSocial} />
                    </View>
                </View>
                <BadgeListSection title="Professional Skills" items={technicalSkills} />
                <BadgeListSection title="Soft Skills" items={softSkills} />
                <BadgeListSection title="Languages Known" items={languages} />
                <ExperienceSection jobData={jobData} />
                <EducationSection educationData={educationData} />
                <ReferencesSection referenceData={referenceData} />
            </Page>
        </Document>
    );
}

export default Template7Pdf;